var helperGetDateTime = require('./helperGetDateTime')
var helperGetYMD = require('./helperGetYMD')

function helperGetYMDTime (date) {
  return helperGetDateTime(helperGetYMD(date))
}

module.exports = helperGetYMDTime



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperGetYMDTime.js
// module id = 512
// module chunks = 98